// extracted by extract-css-chunks-webpack-plugin
module.exports = {"text":"ROQq6d","categoryTitleMargin":"_2NeYWp"};